import style from './index.module.scss';
import React, { InputHTMLAttributes } from 'react';
import cls from 'classnames';

export const Radio = (props: InputHTMLAttributes<HTMLInputElement> & { label?: string | React.JSX.Element }) => {
  const newProps = { ...props };
  delete newProps.label;
  return (
    <label className={style.reason_radio}>
      <div className={cls(style.reason_radio_box, {
        [style.reason_radio_box_checked]: props.checked,
      })}
      >
        <input
          type="checkbox"
          {...newProps}
        />
      </div>
      <div className={style.reason_radio_title}>
        {props.label}
      </div>
    </label>
  );
};